import crudGenerator from './generators/crud'
import sortableGenerator from './generators/sortable'
import searchableGenerator from './generators/searchable'
import autocompleteGenerator from './generators/autocomplete'
import accessibleGenerator from './generators/accessible'
import selectableGenerator from './generators/selectable'

export function crud (list = {}) {
    const modules = {}

    Object.keys(list).forEach(module => {
        if (module.includes('/')) {
            const nested = module.split('/');

            let prevModule = null;
            let prev = '';

            nested.forEach(piece => {
                if (prevModule === null) {
                    prevModule = modules[piece];
                    prev += piece;
                } else {
                    if (! prevModule.modules) {
                        prevModule.modules = {};
                    }
                    prev += '/' + piece;
                    if (!prevModule.modules[piece]) {
                        if (list[prev]) {
                            prevModule.modules[piece] = crudGenerator(list[prev]);
                        } else {
                            prevModule.modules[piece] = {};
                        }
                    }
                }
            });
        } else {
            modules[module] = crudGenerator(list[module])
        }
    })

    return modules
}

export function sortable (list = {}) {
    const modules = {}

    Object.keys(list).forEach(module => {
        modules[module] = sortableGenerator(list[module])
    })

    return modules
}

export function searchable (list = {}) {
    const modules = {}

    Object.keys(list).forEach(module => {
        modules[module] = searchableGenerator(list[module])
    })

    return modules
}

export function autocomplete (list = {}) {
    const modules = {}

    Object.keys(list).forEach(module => {
        modules[module] = autocompleteGenerator(list[module])
    })

    return modules
}

export function accessible (list = {}) {
    const modules = {}

    Object.keys(list).forEach(module => {
        if (module.includes('/')) {
            const nested = module.split('/');

            let prevModule = null;
            let prev = '';

            nested.forEach(piece => {
                if (prevModule === null) {
                    prevModule = modules[piece];
                    prev += piece;
                } else {
                    if (! prevModule.modules) {
                        prevModule.modules = {};
                    }
                    prev += '/' + piece;
                    if (!prevModule.modules[piece]) {
                        if (list[prev]) {
                            prevModule.modules[piece] = accessibleGenerator(list[prev]);
                        } else {
                            prevModule.modules[piece] = {};
                        }
                    }
                }
            });
        } else {
            modules[module] = accessibleGenerator(list[module])
        }
    });

    return modules
}

export function selectable (list = {}) {
    const modules = {}

    Object.keys(list).forEach(module => {
        modules[module] = selectableGenerator(list[module])
    })

    return modules
}
